import {
  RECORD_LOAD,
  RECORD_LOAD_SUCCESS
} from "./actions";

const initialState = {
  planData: null,
  recordData: null
};

export function recordReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case RECORD_LOAD:
      return {
        ...state,
        planData: null,
        recordData: null
      };

    case RECORD_LOAD_SUCCESS:
      return {
        ...state,
        planData: data.plan,
        recordData: data.recordData
      };

    default:
      return state;
  }
}
